import React, { useEffect, useState } from "react";
import ScorePopUp from "./ScorePopUp";
import AllQuestions from "./QuestionCompleted/AllQuestions";
import { useSelector } from "react-redux";
import axios from "../../../axios";
import moment from "moment";
import { SubjectIcon } from "../../../SubjectIcon";
import { NavLink } from "react-router-dom";
import { Tooltip } from "@mui/material";
import { BookText, CalendarDays } from "lucide-react";
import { shortenParagraph } from "../../../utils/Engagement";

export default function CompletedAss({ filter }) {
  const [completeAss, setCompletedAss] = useState({
    openScorePopUp: false,
    viewAnswers: false,
    assessmentId: null,
    checkAdaptive: false,
  });

  const [completedCard, setCompletedCard] = useState([]);
  const currentUser = useSelector((state) => state.user.currentUser);
  const [isGettingData, setIsGettingData] = useState(true);
  const [openCompleteAss, setOpenCompleteAss] = useState(false);

  useEffect(() => {
    const completedBox = async () => {
      try {
        let response = await axios.get(
          `/assessment/filterByStudentId/${currentUser?.id}/completed?_page=${filter?.page}&_limit=${filter?.limit}&sortBy=${filter?.sortBy}` +
            `${
              filter?.date
                ? `&date=${moment(filter?.date).format("YYYY-MM-DD")}`
                : ``
            }` +
            `${filter?.time ? `&time=${filter?.time}` : ``}` +
            `${
              filter?.subjectId?.length !== 0
                ? `&subjectId=${filter?.subjectId}`
                : ``
            }`
        );
        response && setCompletedCard(response.data.data);
        setIsGettingData(false);
      } catch (error) {
        setIsGettingData(false);
        console.log(error);
      }
    };
    completedBox();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const userOffset = dateObj.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
    const localDate = new Date(dateObj - userOffset); // Convert to local time

    const day = localDate.getDate().toString().padStart(2, "0");
    const month = (localDate.getMonth() + 1).toString().padStart(2, "0");
    const year = localDate.getFullYear();
    const outputDateString = `${day}/${month}/${year}`;
    return outputDateString;
  };

  const handleViewAnswer = () => {
    setCompletedAss({
      ...completeAss,
      viewAnswers: true,
    });
  };
  const handleViewAnswerQuestionFalse = () => {
    setCompletedAss({
      ...completeAss,
      viewAnswers: false,
      openScorePopUp: false,
      checkAdaptive: false,
      checkAutoEvalution: false,
    });
  };

  const handleOpen = () => {
    var sidebar = document.querySelector("shouldIOpen");
    var body = document.querySelector("body");

    body.addEventListener("click", function (event) {
      if (!sidebar.contains(event.target)) {
        sidebar.classList.remove("isOpened");
      }
    });

    sidebar.addEventListener("click", function (event) {
      event.stopPropagation();
      sidebar.classList.add("isOpened");
    });
  };

  return (
    <div>
      {completedCard && completedCard.length > 0 ? (
        <div className="totalPenadingAssContainer">
          <div className="d-flex gap-4 mt-3 flex-wrap">
            {completedCard?.map((item, index) => (
              // <div
              //   className={`containerForPendinDeatailAss ${
              //     completeAss?.assessmentId === item?.id && "cardIsActive"
              //   } p-3`}
              //   onClick={(e) => {
              //     setCompletedAss({
              //       ...completeAss,
              //       openScorePopUp: true,
              //       assessmentId: item?.id,
              //     });
              //   }}
              //   key={index}
              // >
              //   <div className="kannadaHeaderAss">{item?.subject?.name}</div>
              //   <div className="headingOfAss mt-2">{item?.name}</div>
              //   <span className="deadlineAss">Submitted</span> &nbsp;
              //   <span className="deadlineDateAss">
              //     {timeHelper(item?.submitted_on)}
              //   </span>
              //   <div className="d-flex justify-content-end">
              //     <span className="marksComplAss">
              //       {item?.obtained_marks}/{item?.total_marks}
              //     </span>
              //   </div>
              // </div>
              <div
                key={index}
                // className="summarySubBoxContainerHW"
                className="w-80 h-32 d-flex flex-column py-2 px-3 text-start shadow-sm rounded-4 cursor-pointer card_style"
                style={{
                  borderTop: `8px solid #${item?.subject?.subject_color}`,
                }}
                onClick={(e) => {
                  setCompletedAss({
                    ...completeAss,
                    openScorePopUp: true,
                    assessmentId: item?.id,
                    checkAdaptive: item.isAdaptive,
                    checkAutoEvalution: item.autoEvalEnabled,
                  });
                }}
              >
                <div className="d-flex SubsummarySubBoxContainer justify-content-between align-items-center">
                  <div>
                    <div className="subboxSubjectName">
                      {item?.subject?.name}
                    </div>
                  </div>
                  <div>
                    <img
                      src={`${
                        SubjectIcon?.find(
                          (i) => i.subjectName === item?.subject?.name
                        )?.icon
                      }`}
                      alt=""
                    />
                  </div>
                </div>
                <div
                  className="SubsummarySubBoxContainer"
                  style={{ paddingTop: "0", position: "relative" }}
                >
                  <div className="headingOfHW" title={item?.name}>
                    {
                      <Tooltip
                        title={item?.name}
                        arrow
                        placement="bottom"
                        enterDelay={200}
                        leaveDelay={100}
                      >
                        <div className="flex">
                          <BookText size={16} className="me-2 mt-1 text-dark" />
                          {shortenParagraph(item?.name, 20)}
                        </div>
                      </Tooltip>
                    }
                  </div>
                  <div className="flex mt-2">
                    <CalendarDays size={16} className="me-2 text-dark" />
                    <span className="deadline">Submitted:</span> &nbsp;
                    <span className="deadlineDate">
                      {moment(item?.submitted_on).local().format("DD-MM-YYYY")}
                    </span>
                    {item.isAdaptive && (
                      <span
                        style={{
                          padding: "7px 12px",
                          position: "absolute",
                          top: "25px",
                          right: "-10px",
                          borderRadius: "6px",
                        }}
                        onClick={(e) => {
                          setOpenCompleteAss(true);
                          e.stopPropagation();
                        }}
                      >
                        <img
                          src="/images/adaptiveImg.png"
                          alt="img"
                          style={{ width: "90px" }}
                        />
                      </span>
                    )}
                    {item.autoEvalEnabled && (
                      <span
                        style={{
                          padding: "0px 12px",
                          position: "absolute",
                          top: "15px",
                          right: "-15px",
                          borderRadius: "6px",
                        }}
                        onClick={(e) => {
                          setOpenCompleteAss(true);
                          e.stopPropagation();
                        }}
                      >
                        <img
                          src="/images/auto-eva.png"
                          alt="img"
                          style={{ width: "60px" }}
                        />
                      </span>
                    )}
                  </div>
                  <div className="d-flex justify-content-end me-2 headingOfHW">
                    {item.isAdaptive
                      ? typeof item?.ability === "number"
                        ? item.ability < 0
                          ? "Score: 0"
                          : "Score: " + item.ability.toFixed(2)
                        : "--"
                      : `Marks: ${item.obtained_marks}/${item.total_marks}`}
                  </div>
                </div>
              </div>
            ))}
          </div>
          {completeAss.openScorePopUp && (
            <ScorePopUp
              handleViewAnswerQuestionFalse={handleViewAnswerQuestionFalse}
              handleViewAnswer={handleViewAnswer}
              assessmentId={completeAss?.assessmentId}
              completeAss={completeAss}
              isOpen={completeAss?.openScorePopUp}
            />
          )}

          {completeAss.viewAnswers && (
            <AllQuestions
              handleViewAnswerQuestionFalse={handleViewAnswerQuestionFalse}
              assessmentId={completeAss?.assessmentId}
              completeAss={completeAss}
            />
          )}

          {completeAss.viewAnswers && openCompleteAss && (
            <AllQuestions
              handleViewAnswerQuestionFalse={handleViewAnswerQuestionFalse}
              assessmentId={completeAss?.assessmentId}
              completeAss={completeAss}
            />
          )}
        </div>
      ) : isGettingData ? (
        <img className="ongoing_loader" src="/gif/LoaderDot.gif" alt="" />
      ) : (
        <div className="d-flex justify-content-center align-items-center h-20 w-100">
          <span
            className="px-2 py-2 d-flex align-items-center gap-2"
            style={{ fontSize: "1.2rem", fontWeight: 500 }}
          >
            🧾 Assessment Not Found
          </span>
        </div>
      )}
    </div>
  );
}
